import { render, staticRenderFns } from "./MatricesSubjects.vue?vue&type=template&id=4259d613&scoped=true&"
import script from "./MatricesSubjects.vue?vue&type=script&lang=js&"
export * from "./MatricesSubjects.vue?vue&type=script&lang=js&"
import style0 from "./MatricesSubjects.vue?vue&type=style&index=0&id=4259d613&lang=scss&scoped=true&"
import style1 from "./MatricesSubjects.vue?vue&type=style&index=1&id=4259d613&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4259d613",
  null
  
)

export default component.exports